import React from 'react';
import { isEmpty } from 'lodash';

import Breadcrumb from 'components/consumer/consumer-breadcrumb';
import usePDPBreadcrumbs from 'data-hooks/usePDPBreadcrumbs';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';

const PDPBreadCrumbsInner = () => {
  const breadCrumbData = usePDPBreadcrumbs();

  return !isEmpty(breadCrumbData) ? (
    <>
      <MobileAndTabletOnly>
        <div className="lg:hidden">
          <Breadcrumb
            color="dark"
            forPage="PDPMobile"
            config={{
              items: breadCrumbData.data,
            }}
          />
        </div>
      </MobileAndTabletOnly>

      <DesktopOnly>
        <div className="max-[1023px]:hidden">
          <Breadcrumb
            color="light"
            forPage="PDP"
            config={{
              items: breadCrumbData.data,
            }}
          />
        </div>
      </DesktopOnly>
    </>
  ) : null;
};

const PDPBreadCrumbs = props => (
  <SuspenseWithLoader>
    <PDPBreadCrumbsInner {...props} />
  </SuspenseWithLoader>
);

export default PDPBreadCrumbs;
